import { render, staticRenderFns } from "./ques-person.vue?vue&type=template&id=15559db7&scoped=true"
import script from "./ques-person.vue?vue&type=script&lang=js"
export * from "./ques-person.vue?vue&type=script&lang=js"
import style0 from "./ques-person.vue?vue&type=style&index=0&id=15559db7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15559db7",
  null
  
)

export default component.exports